module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAlElEQVR4AWOgC7CddJZIRA0N1Vvv3n797cmHH0CyYcc9Ahpqtt69+PRz4NxLQLb/nEuH7r6v234Pn4a7b74FgFU7TT2Xt+5W4fpbEQuv4NMAdAmEMfHgY6BVScuvRy66QpQN2WtuOkw5l7n6xoO33wn7IWjeJaDqko23Zxx9UrbpDlGh9Ozjz6cffkAQsiwdIm5QAgCKxxGBKkgh5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_gosquared.png
// module id = 1313
// module chunks = 0